<template>
    <div class="form-group" :class="{disabled: disabled}">
        <label 
            :for="id" 
            class="pppp-label"
            :class="{'sr-only': hideLabel}">
            {{ getLabel }}
        </label>
        <select 
            v-model="value"
            :id="id" 
            :name="getName" 
            class="form-select pppp-select" 
            :required="required" 
            :disabled="disabled">
            <option v-if="placeholder" :value="null">{{ placeholder }}</option>
            <option v-for="option in options" :key="option.value" :value="option.value">{{ option.text }}</option>
        </select>
        <div v-if="required" class="pppp-validation-msg">
            <span class="glyphicon glyphicon-exclamation-sign"></span> Tämä kenttä on pakollinen!
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormInput',
    props: {
        modelValue: String,
        id:  String,
        name: String,
        label: String,
        placeholder: String,
        options: Array,
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        hideLabel: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue'],
    computed: {
        getLabel() {
            if (this.required) {
                return '* ' + this.label;
            }
            return this.label;
        },
        getName() {
            if (! this.name) {
                return this.id;
            }
            return this.name;
        },
        value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        }
    }
}
</script>

<style scoped>

</style>
